export const styles = {
  button: {
    minWidth: '0',
  },
}
